var metric, imperial;

metric = {
  Pa: {
    name: {
      singular: "pascal",
      plural: "pascals",
    },
    to_anchor: 1 / 1000,
  },
  kPa: {
    name: {
      singular: "kilopascal",
      plural: "kilopascals",
    },
    to_anchor: 1,
  },
  MPa: {
    name: {
      singular: "megapascal",
      plural: "megapascals",
    },
    to_anchor: 1000,
  },
  hPa: {
    name: {
      singular: "hectopascal",
      plural: "hectopascals",
    },
    to_anchor: 1 / 10,
  },
  bar: {
    name: {
      singular: "bar",
      plural: "bar",
    },
    to_anchor: 100,
  },
  mbar: {
    name: {
      singular: "millibar",
      plural: "millibar",
    },
    to_anchor: 1 / 10,
  },
  torr: {
    name: {
      singular: "torr",
      plural: "torr",
    },
    to_anchor: 101325 / 760000,
  },
  "kg/cm²": {
    name: {
      singular: "Kg_cm_sq",
      plural: "Kg_cm_sq",
    },
    to_anchor: 98.0665,
  },
  "kgf/cm²": {
    name: {
      singular: "kilogram-force per square centimeter",
      plural: "kilogram-force per square centimeter",
    },
    to_anchor: 98.0665,
  },
  mmHg: {
    name: {
      singular: "Millimeters of mercury",
      plural: "Millimeters of mercury",
    },
    to_anchor: 0.133322,
  },
  inHg: {
    name: {
      singular: "Inches of mercury",
      plural: "Inches of mercury",
    },
    to_anchor: 3.386389,
  },
    cmHg: {
    name: { singular: "Centimeter of mercury", plural: "Centimeters of mercury" },
    to_anchor: 1.33322, // ✅ 1 cmHg = 1.33322 kPa
  },
  mmWC: {
    name: {
      singular: "Millimeters of water column",
      plural: "Millimeters of water column",
    },
    to_anchor: 0.00980665,
  },
  "mmH₂O": {
    name: {
      singular: "millimeter of water column",
      plural: "millimeters of water column",
    },
    to_anchor: 0.00980665,
  },
  "cmH₂O": {
    name: {
      singular: "centimeter of water column",
      plural: "centimeters of water column",
    },
    to_anchor: 0.0980665, // Conversion: 1 cmH₂O = 0.0980665 kPa
  },
};

imperial = {
  psi: {
    name: {
      singular: "pound per square inch",
      plural: "pounds per square inch",
    },
    to_anchor: 1 / 1000,
  },
  ksi: {
    name: {
      singular: "kilopound per square inch",
      plural: "kilopound per square inch",
    },
    to_anchor: 1,
  },
  mmhg: {
    name: {
      singular: "Millimeters of mercury",
      plural: " Millimeters of mercury",
    },
    to_anchor: 1 / 51715.075480416,
  },
  InWC: {
    name: {
      singular: "Inches of water column",
      plural: "Inches of water column",
    },
    to_anchor: 1 / 2777.778111,
  },
  "ton/in²": {
    name: {
      singular: "ton per square inch",
      plural: "tons per square inch",
    },
    to_anchor: 2, // 1 ton/in² = 2000 psi = 2 ksi
  },
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: "kPa",
      ratio: 0.00014503768078,
    },
    imperial: {
      unit: "psi",
      ratio: 1 / 0.00014503768078,
    },
  },
};
